import React, { Component, PropTypes } from 'react';
import CourseTableOfContents from './CourseTableOfContents';
import { CourseStore } from 'stores';
import { CourseActions } from 'actions';
import Loader from 'components/Material/Loader';
import { mixin, RefluxMixin } from 'Util';

class CourseTableOfContentsContainer extends mixin(RefluxMixin, Component) {
  static propTypes = {
    courseId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  };

  listenToStores() {
    this.listenToStoreWithMapper(
      CourseStore,
      state => {
        return {
          toc: state.toc.list,
          loading: state.toc.loading
        };
      },
      {
        toc: [],
        loading: true
      }
    );
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.state.toc !== nextState.toc;
  }

  componentDidMount() {
    const { courseId } = this.props;
    CourseActions.getGuestToc(courseId);
  }

  render() {
    const { loading, toc } = this.state;
    if (loading) {
      return <Loader />;
    }
    return <CourseTableOfContents toc={toc} />;
  }
}

export default CourseTableOfContentsContainer;



// WEBPACK FOOTER //
// ./src/js/components/Store/CourseTableOfContentsContainer.js